import { render, staticRenderFns } from "./DemoReviewsList.vue?vue&type=template&id=8327adae&scoped=true"
import script from "./DemoReviewsList.vue?vue&type=script&lang=js"
export * from "./DemoReviewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8327adae",
  null
  
)

export default component.exports